export type MatterCodeGroups = {
	task_group: string | null;
	activity_group: string | null;
};

/** Keep the firm matrix in sync with backend's src/domain/matterBillingCodes.ts. */
export function matterCodeRequirements(firm: string, matter: MatterCodeGroups) {
	const taskGroup = Boolean(matter.task_group?.trim());
	const activityGroup = Boolean(matter.activity_group?.trim());
	const taskRequired = [
		"taylorday",
		"namanhowell",
		"bpmlaw",
		"tysonmendes",
		"gouldratner",
	].includes(firm)
		? taskGroup
		: true;
	const activityRequired = ["namanhowell", "gouldratner"].includes(firm)
		? taskGroup
		: ["taylorday", "pregodonnell", "bpmlaw"].includes(firm)
			? activityGroup
			: true;
	return { taskRequired, activityRequired };
}

/** No resolved matter means pending/unassigned, not a matter with no groups. */
export function applicableMatterCodes<T, A>(
	firm: string,
	matter: MatterCodeGroups | null | undefined,
	task: T | null,
	activity: A | null,
): { task: T | null; activity: A | null } {
	if (!matter) return { task, activity };
	const requirements = matterCodeRequirements(firm, matter);
	return {
		task: requirements.taskRequired ? task : null,
		activity: requirements.activityRequired ? activity : null,
	};
}
